import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Heart, Users, Award } from 'lucide-react';
import { about, siteInfo } from '../data/mockData';

const QuemSomos = () => {
  const valores = [
    {
      icon: Heart,
      title: 'Humanização',
      description: 'Tratamos cada família com empatia, respeito e dedicação, oferecendo acolhimento verdadeiro em momentos difíceis.'
    },
    {
      icon: Award,
      title: 'Excelência',
      description: 'Padrão de excelência em todos os serviços, com profissionais capacitados e infraestrutura completa.'
    },
    {
      icon: Users,
      title: 'Compromisso',
      description: 'Compromisso com a dignidade e respeito em cada detalhe, desde o primeiro contato até o apoio pós-despedida.'
    }
  ];

  const diferenciais = [
    'Mais de 18.000 famílias atendidas',
    'Atendimento 24 horas no Meier',
    'Equipe especializada e humanizada',
    'Infraestrutura completa',
    'Atendimento personalizado',
    'Suporte pós-funerário'
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center text-white bg-gradient-to-r from-gray-800 to-gray-900">
        <div className="text-center px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Quem Somos</h1>
          <p className="text-xl text-gray-300">Referência em serviços funerários no Meier</p>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src={about.image}
                alt="Santa Casa Serviço Funerário Imediato"
                className="rounded-lg shadow-2xl w-full h-[500px] object-cover"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Nossa História</h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                {about.description}
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                Oferecemos um portfólio completo de serviços: sepultamento, cremação, translado nacional e internacional, 
                sempre com discrição, agilidade e respeito absoluto. Nossa equipe está disponível 24 horas para oferecer 
                suporte e orientação em todos os momentos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">Nossos Valores</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {valores.map((valor, index) => {
              const Icon = valor.icon;
              return (
                <div key={index} className="bg-white rounded-2xl shadow-lg p-8 text-center hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-lime-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">{valor.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{valor.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">Nossos Diferenciais</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {diferenciais.map((diferencial, index) => (
              <div key={index} className="flex items-start space-x-3 bg-gray-50 rounded-lg p-6">
                <CheckCircle className="w-5 h-5 text-lime-600 flex-shrink-0 mt-1" />
                <span className="text-gray-800 text-lg">{diferencial}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-r from-teal-500 to-lime-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-4">Estamos aqui para ajudar</h2>
          <p className="text-xl mb-8 text-teal-50">
            Nossa equipe está disponível 24 horas para oferecer o suporte que você precisa no Meier e região.
          </p>
          <Link
            to="/contato"
            className="inline-block bg-white text-lime-600 hover:bg-gray-100 px-8 py-4 rounded-md text-lg font-medium transition-all duration-300 hover:shadow-2xl hover:scale-105"
          >
            Entre em Contato
          </Link>
        </div>
      </section>
    </div>
  );
};

export default QuemSomos;
